import { render, staticRenderFns } from "./park-user.vue?vue&type=template&id=c20795a8&scoped=true&"
import script from "./park-user.vue?vue&type=script&lang=js&"
export * from "./park-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20795a8",
  null
  
)

export default component.exports